import { homePageData } from '@data-ts/pages/home';

export type AssetType = { path: string; className: string; style?: Object };

export type Feature = {
  id: string;
  to: string;
  label: string;
  desc: string;
  assetDeskop?: string;
  assetMobile: string;
  showInMobile?: boolean;
};

const sectionData = homePageData.sections.features;

export const featureItems: Feature[] = [
  {
    id: 'home-features-to-wedding-website',
    to: '/wedding-website',
    label: sectionData.weddingWebsite.listItemLabel,
    desc: 'Beautiful, free and uniquely yours, with smart features for all your planning needs.',
    assetDeskop: 'find-an-event/planning_section_wedding_website.jpg',
    assetMobile: 'find-an-event/planning_section_wedding_website_mobile.jpg',
  },
  {
    id: 'home-features-to-guest-list',
    to: '/guest-list',
    label: sectionData.guestList.listItemLabel,
    desc: 'Organize and track every detail of your nuptials from your free planning hub.',
    assetDeskop: 'find-an-event/planning_section_guest_list.jpg',
    assetMobile: 'find-an-event/planning_section_guest_list_mobile.jpg',
  },
  {
    id: 'home-features-save-the-dates',
    to: '/save-the-date',
    label: sectionData.saveTheDates.listItemLabel,
    desc: 'Hundreds of design options to announce your wedding in style. Send for free online or order matching prints.',
    assetDeskop: 'find-an-event/planning_section_save_the_dates.jpg',
    assetMobile: 'find-an-event/planning_section_save_the_dates_mopbile.jpg',
  },
  {
    id: 'home-features-to-invitations',
    to: '/wedding-invitations',
    label: sectionData.invitations.listItemLabel,
    desc: 'Design the perfect invitation for your big day. Send for free online or order matching prints.',
    assetDeskop: 'find-an-event/planning_section_invitations.jpg',
    assetMobile: 'find-an-event/planning_section_invitations_mobile.jpg',
  },
  {
    id: 'home-features-to-smart-rsvp',
    to: '/online-rsvp',
    label: sectionData.smartRSVP.listItemLabel,
    desc: 'Ask any question and track every answer with powerful and free Smart RSVP.',
    assetDeskop: 'find-an-event/planning_section_smart_rsvp.jpg',
    assetMobile: 'find-an-event/planing_section_smart_rsvp_mobile.jpg',
  },
  {
    id: 'home-features-to-registry',
    to: '/registry',
    label: sectionData.registry.listItemLabel,
    desc: 'Your All-in-One registry, from gifts, to zero-fee cash funds, to honeymoon experiences.',
    assetDeskop: 'find-an-event/planning_section_wedding_registry.jpg',
    assetMobile: 'find-an-event/planning_section_wedding_registry_mobile.jpg',
  },
  {
    id: 'home-features-to-guest-app',
    to: '/app',
    label: sectionData.guestApp.listItemLabel,
    showInMobile: true,
    desc: 'Every detail at your fingertips with a free mobile app to match your website.',
    assetMobile: 'find-an-event/planning_section_mobile_app_mobile.jpg',
  },
];
